"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6326],{

/***/ 6326:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "PopularServices": function() { return /* binding */ PopularServices; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./components/Home/ContentElements/Linklists/Cambelt.tsx



var Cambelt = function(props) {
    var ref = (0,react.useState)(true), isShowing = ref[0], setIsShowing = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "col-span-6 md:col-span-4 xl:col-span-3 mb-3",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: "text-sm leading-5 md:text-base md:leading-6 font-semibold text-gray-500 text-left",
                onClick: function() {
                    return setIsShowing(function(isShowing) {
                        return !isShowing;
                    });
                },
                children: "Zahnriemenwechsel"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "collapseable ".concat(!isShowing && "h-0", " ").concat(isShowing && "h-full", " overflow-hidden transition-[height] duration-700"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    className: "mt-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/zahnriemenwechsel-audi-a4/",
                                title: "Zahnriemenwechsel A4",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Zahnriemenwechsel A4"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/zahnriemenwechsel-renault-scenic/",
                                title: "Zahnriemenwechsel Renault Scenic",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Zahnriemenwechsel Renault Scenic"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/zahnriemenwechsel-vw-polo/",
                                title: "Zahnriemenwechsel Polo",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Zahnriemenwechsel Polo"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/zahnriemenwechsel-ford-focus/",
                                title: "Zahnriemenwechsel Ford Focus",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Zahnriemenwechsel Ford Focus"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/zahnriemenwechsel-vw-golf-4/",
                                title: "Zahnriemenwechsel Golf 4",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Zahnriemenwechsel Golf 4"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/zahnriemenwechsel-golf-5/",
                                title: "Zahnriemenwechsel Golf 5",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Zahnriemenwechsel Golf 5"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/zahnriemenwechsel-vw-golf-6/",
                                title: "Zahnriemenwechsel Golf 6",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Zahnriemenwechsel Golf 6"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/zahnriemenwechsel-golf-7/",
                                title: "Zahnriemenwechsel Golf 7",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Zahnriemenwechsel Golf 7"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/zahnriemenwechsel-audi-a3/",
                                title: "Zahnriemenwechsel A3",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Zahnriemenwechsel A3"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/zahnriemenwechsel-vw-tiguan/",
                                title: "Zahnriemenwechsel Tiguan",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Zahnriemenwechsel Tiguan"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/zahnriemenwechsel-ford-fiesta/",
                                title: "Zahnriemenwechsel Ford Fiesta",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Zahnriemenwechsel Ford Fiesta"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/zahnriemenwechsel-fiat-500/",
                                title: "Zahnriemenwechsel Fiat 500",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Zahnriemenwechsel Fiat 500"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/zahnriemenwechsel-seat-leon/",
                                title: "Zahnriemenwechsel Seat Leon",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Zahnriemenwechsel Seat Leon"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/zahnriemenwechsel-skoda-fabia/",
                                title: "Zahnriemenwechsel Skoda Fabia",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Zahnriemenwechsel Skoda Fabia"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/skoda-octavia-zahnriemenwechsel-wann/",
                                title: "Zahnriemenwechsel Skoda Octavia",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Zahnriemenwechsel Skoda Octavia"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/zahnriemenwechsel-vw-caddy/",
                                title: "Zahnriemenwechsel VW Caddy",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Zahnriemenwechsel VW Caddy"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/zahnriemenwechsel-renault-clio/",
                                title: "Zahnriemenwechsel Renault Clio",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Zahnriemenwechsel Renault Clio"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/zahnriemenwechsel-opel-insignia/",
                                title: "Zahnriemenwechsel Opel Insignia",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Zahnriemenwechsel Opel Insignia"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/zahnriemenwechsel-vw-touran/",
                                title: "Zahnriemenwechsel VW Touran",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Zahnriemenwechsel VW Touran"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/zahnriemenwechsel-audi-a6/",
                                title: "Zahnriemenwechsel Audi A6",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Zahnriemenwechsel Audi A6"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/zahnriemenwechsel-peugeot-207/",
                                title: "Zahnriemenwechsel Peugeot 207",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Zahnriemenwechsel Peugeot 207"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/zahnriemenwechsel-opel-meriva/",
                                title: "Zahnriemenwechsel Opel Meriva",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Zahnriemenwechsel Opel Meriva"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/zahnriemenwechsel-fiat-punto/",
                                title: "Zahnriemenwechsel Fiat Punto",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Zahnriemenwechsel Fiat Punto"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/zahnriemenwechsel-renault-megane/",
                                title: "Zahnriemenwechsel Renault Megane",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Zahnriemenwechsel Renault Megane"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/zahnriemenwechsel-volvo-v70/",
                                title: "Zahnriemenwechsel Volvo V70",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Zahnriemenwechsel Volvo V70"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/zahnriemenwechsel-nissan-qashqai/",
                                title: "Zahnriemenwechsel Nissan Qashqai",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Zahnriemenwechsel Nissan Qashqai"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/zahnriemenwechsel-citroen-berlingo/",
                                title: "Zahnriemenwechsel Citroen Berlingo",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Zahnriemenwechsel Citroen Berlingo"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/zahnriemenwechsel-renault-twingo/",
                                title: "Zahnriemenwechsel Renault Twingo",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Zahnriemenwechsel Renault Twingo"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/zahnriemenwechsel-vw-sharan/",
                                title: "Zahnriemenwechsel VW Sharan",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Zahnriemenwechsel VW Sharan"
                            })
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/Home/ContentElements/Linklists/InspectionWithBrand.tsx



var InspectionWithBrand = function(props) {
    var ref = (0,react.useState)(true), isShowing = ref[0], setIsShowing = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "col-span-6 md:col-span-4 xl:col-span-3 mb-3",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: "text-sm leading-5 md:text-base md:leading-6 font-semibold text-gray-500 text-left",
                onClick: function() {
                    return setIsShowing(function(isShowing) {
                        return !isShowing;
                    });
                },
                children: "Inspektion nach Marke"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "collapseable ".concat(!isShowing && "h-0", " ").concat(isShowing && "h-full", " overflow-hidden transition-[height] duration-700"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    className: "mt-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/inspektion-audi/",
                                title: "Inspektion Audi",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Inspektion Audi"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/inspektion-vw/",
                                title: "Inspektion VW",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Inspektion VW"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/inspektion-bmw/",
                                title: "Inspektion BMW",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Inspektion BMW"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/inspektion-mercedes-benz/",
                                title: "Inspektion Mercedes-Benz",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Inspektion Mercedes-Benz"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/inspektion-ford/",
                                title: "Inspektion Ford",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Inspektion Ford"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/inspektion-opel/",
                                title: "Inspektion Opel",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Inspektion Opel"
                            })
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/Home/ContentElements/Linklists/InspectionWithBrandAndModel.tsx



var InspectionWithBrandAndModel = function(props) {
    var ref = (0,react.useState)(true), isShowing = ref[0], setIsShowing = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "col-span-6 md:col-span-4 xl:col-span-3 mb-3",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "text-sm leading-5 md:text-base md:leading-6 font-semibold text-gray-500 text-left",
                onClick: function() {
                    return setIsShowing(function(isShowing) {
                        return !isShowing;
                    });
                },
                children: "Inspektion nach Marke & Modell"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "collapseable ".concat(!isShowing && "h-0", " ").concat(isShowing && "h-full", " overflow-hidden transition-[height] duration-700"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    className: "mt-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/inspektion-vw-golf-7/",
                                title: "Inspektion VW Golf 7",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Inspektion VW Golf 7"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/inspektion-vw-polo/",
                                title: "Inspektion VW Polo",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Inspektion VW Polo"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/inspektion-skoda-octavia/",
                                title: "Inspektion Skoda Octavia",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Inspektion Skoda Octavia"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/inspektion-bmw-1er/",
                                title: "Inspektion BMW 1er",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Inspektion BMW 1er"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/inspektion-vw-golf-6/",
                                title: "Inspektion VW Golf 6",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Inspektion VW Golf 6"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/inspektion-vw-tiguan/",
                                title: "Inspektion VW Tiguan",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Inspektion VW Tiguan"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/inspektion-mercedes-c-klasse/",
                                title: "Inspektion Mercedes C-Klasse",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Inspektion Mercedes C-Klasse"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/inspektion-bmw-3er/",
                                title: "Inspektion BMW 3er",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Inspektion BMW 3er"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/inspektion-vw-touran/",
                                title: "Inspektion VW Touran",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Inspektion VW Touran"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/inspektion-bmw-5er/",
                                title: "Inspektion BMW 5er",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Inspektion BMW 5er"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/inspektion-skoda-fabia/",
                                title: "Inspektion Skoda Fabia",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Inspektion Skoda Fabia"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/inspektion-opel-insignia/",
                                title: "Inspektion Opel Insignia",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Inspektion Opel Insignia"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/inspektion-hyundai-tucson/",
                                title: "Inspektion Hyundai Tucson",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Inspektion Hyundai Tucson"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/inspektion-opel-mokka/",
                                title: "Inspektion Opel Mokka",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Inspektion Opel Mokka"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/inspektion-seat-ibiza/",
                                title: "Inspektion Seat Ibiza",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Inspektion Seat Ibiza"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/inspektion-vw-caddy/",
                                title: "Inspektion VW Caddy",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Inspektion VW Caddy"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/inspektion-mercedes-b-klasse/",
                                title: "Inspektion Mercedes B-Klasse",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Inspektion Mercedes B-Klasse"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/inspektion-audi-a1/",
                                title: "Inspektion Audi A1",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Inspektion Audi A1"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/inspektion-bmw-2er/",
                                title: "Inspektion BMW 2er",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Inspektion BMW 2er"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/inspektion-vw-golf-5/",
                                title: "Inspektion VW Golf 5",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Inspektion VW Golf 5"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/inspektion-vw-up/",
                                title: "Inspektion VW Up",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Inspektion VW Up"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/inspektion-bmw-x1/",
                                title: "Inspektion BMW X1",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Inspektion BMW X1"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/inspektion-hyundai-i30/",
                                title: "Inspektion Hyundai i30",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Inspektion Hyundai i30"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/inspektion-audi-a5/",
                                title: "Inspektion Audi A5",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Inspektion Audi A5"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/inspektion-skoda-enyaq-iv/",
                                title: "Inspektion Skoda Envaq iV",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Inspektion Skoda Envaq iV"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/inspektion-hyundai-kona-elektro/",
                                title: "Inspektion Hyundai Kona Elektro",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Inspektion Hyundai Kona Elektro"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/inspektion-kia-e-niro/",
                                title: "Inspektion Kia e-Niro",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Inspektion Kia e-Niro"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/inspektion-renault-zoe/",
                                title: "Inspektion Renault Zoe",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Inspektion Renault Zoe"
                            })
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/Home/ContentElements/Linklists/OilChangeWithModel.tsx



var OilChangeWithModel = function(props) {
    var ref = (0,react.useState)(true), isShowing = ref[0], setIsShowing = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "col-span-6 md:col-span-4 xl:col-span-3 mb-3",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: "text-sm leading-5 md:text-base md:leading-6 font-semibold text-gray-500 text-left",
                onClick: function() {
                    return setIsShowing(function(isShowing) {
                        return !isShowing;
                    });
                },
                children: "\xd6lwechsel nach Modell"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "collapseable ".concat(!isShowing && "h-0", " ").concat(isShowing && "h-full", " overflow-hidden transition-[height] duration-700"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    className: "mt-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/oelwechsel-vw-golf-4/",
                                title: "\xd6lwechsel Golf 4",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "\xd6lwechsel Golf 4"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/oelwechsel-vw-golf-5/",
                                title: "\xd6lwechsel Golf 5",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "\xd6lwechsel Golf 5"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/oelwechsel-vw-golf-6/",
                                title: "\xd6lwechsel Golf 6",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "\xd6lwechsel Golf 6"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/oelwechsel-vw-golf-7/",
                                title: "\xd6lwechsel Golf 7",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "\xd6lwechsel Golf 7"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/oelwechsel-ford-fiesta/",
                                title: "\xd6lwechsel Ford Fiesta",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "\xd6lwechsel Ford Fiesta"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/oelwechsel-ford-focus/",
                                title: "\xd6lwechsel Ford Focus",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "\xd6lwechsel Ford Focus"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/oelwechsel-fiat-ducato/",
                                title: "\xd6lwechsel Fiat Ducato",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "\xd6lwechsel Fiat Ducato"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/oelwechsel-skoda-octavia/",
                                title: "\xd6lwechsel Skoda Octavia",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "\xd6lwechsel Skoda Octavia"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/oelwechsel-vw-polo/",
                                title: "\xd6lwechsel VW Polo",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "\xd6lwechsel VW Polo"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/oelwechsel-audi-a6/",
                                title: "\xd6lwechsel Audi A6",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "\xd6lwechsel Audi A6"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/oelwechsel-vw-tiguan/",
                                title: "\xd6lwechsel VW Tiguan",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "\xd6lwechsel VW Tiguan"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/oelwechsel-opel-astra/",
                                title: "\xd6lwechsel Opel Astra",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "\xd6lwechsel Opel Astra"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/oelwechsel-mercedes-c-klasse/",
                                title: "\xd6lwechsel Mercedes C-Klasse",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "\xd6lwechsel Mercedes C-Klasse"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/oelwechsel-vw-touran/",
                                title: "\xd6lwechsel VW Touran",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "\xd6lwechsel VW Touran"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/oelwechsel-bmw-x1/",
                                title: "\xd6lwechsel BMW X1",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "\xd6lwechsel BMW X1"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/oelwechsel-audi-a3/",
                                title: "\xd6lwechsel Audi A3",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "\xd6lwechsel Audi A3"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/oelwechsel-audi-q5/",
                                title: "\xd6lwechsel Audi Q5",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "\xd6lwechsel Audi Q5"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/oelwechsel-opel-corsa/",
                                title: "\xd6lwechsel Opel Corsa",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "\xd6lwechsel Opel Corsa"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/oelwechsel-seat-ibiza/",
                                title: "\xd6lwechsel Seat Ibiza",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "\xd6lwechsel Seat Ibiza"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/oelwechsel-bmw-x5/",
                                title: "\xd6lwechsel BMW X5",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "\xd6lwechsel BMW X5"
                            })
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/Home/ContentElements/Linklists/TireChangeWithCity.tsx



var TireChangeWithCity = function(props) {
    var ref = (0,react.useState)(true), isShowing = ref[0], setIsShowing = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "col-span-6 md:col-span-4 xl:col-span-3 mb-3",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "text-sm leading-5 md:text-base md:leading-6 font-semibold text-gray-500 text-left",
                onClick: function() {
                    return setIsShowing(function(isShowing) {
                        return !isShowing;
                    });
                },
                children: "Reifenwechsel nach Stadt"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "collapseable ".concat(!isShowing && "h-0", " ").concat(isShowing && "h-full", " overflow-hidden transition-[height] duration-700"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    className: "mt-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/reifenwechsel-berlin/",
                                title: "Reifenwechsel Berlin",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Reifenwechsel Berlin"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/reifenwechsel-hamburg/",
                                title: "Reifenwechsel Hamburg",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Reifenwechsel Hamburg"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/reifenwechsel-muenchen/",
                                title: "Reifenwechsel M\xfcnchen",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Reifenwechsel M\xfcnchen"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/reifenwechsel-koeln/",
                                title: "Reifenwechsel K\xf6ln",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Reifenwechsel K\xf6ln"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/reifenwechsel-frankfurt/",
                                title: "Reifenwechsel Frankfurt",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Reifenwechsel Frankfurt"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/reifenwechsel-stuttgart/",
                                title: "Reifenwechsel Stuttgart",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Reifenwechsel Stuttgart"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/reifenwechsel-duesseldorf/",
                                title: "Reifenwechsel D\xfcsseldorf",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Reifenwechsel D\xfcsseldorf"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/reifenwechsel-dortmund/",
                                title: "Reifenwechsel Dortmund",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Reifenwechsel Dortmund"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/reifenwechsel-leipzig/",
                                title: "Reifenwechsel Leipzig",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Reifenwechsel Leipzig"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/reifenwechsel-duisburg/",
                                title: "Reifenwechsel Duisburg",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Reifenwechsel Duisburg"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/reifenwechsel-wuppertal/",
                                title: "Reifenwechsel Wuppertal",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Reifenwechsel Wuppertal"
                            })
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/Home/ContentElements/Linklists/CommonIssues.tsx



var CommonIssues = function(props) {
    var ref = (0,react.useState)(true), isShowing = ref[0], setIsShowing = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "col-span-6 md:col-span-4 xl:col-span-3 mb-3",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: "text-sm leading-5 md:text-base md:leading-6 font-semibold text-gray-500 text-left",
                onClick: function() {
                    return setIsShowing(function(isShowing) {
                        return !isShowing;
                    });
                },
                children: "H\xe4ufige Defekte"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "collapseable ".concat(!isShowing && "h-0", " ").concat(isShowing && "h-full", " overflow-hidden transition-[height] duration-700"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    className: "mt-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/lichtmaschine-defekt/",
                                title: "Lichtmaschine defekt",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Lichtmaschine defekt"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/auspuff-defekt/",
                                title: "Auspuff defekt",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Auspuff defekt"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/anlasser-defekt/",
                                title: "Anlasser defekt",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Anlasser defekt"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/oeldruckschalter-defekt/",
                                title: "\xd6ldruckschalter defekt",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "\xd6ldruckschalter defekt"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/abs-sensor-defekt/",
                                title: "ABS-Sensor defekt",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "ABS-Sensor defekt"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/spurstangenkopf-defekt/",
                                title: "Spurstangenkopf defekt",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Spurstangenkopf defekt"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/auto-springt-nicht-an/",
                                title: "Auto springt nicht an",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Auto springt nicht an"
                            })
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/Home/ContentElements/Linklists/TurboCharger.tsx



var TurboCharger = function(props) {
    var ref = (0,react.useState)(true), isShowing = ref[0], setIsShowing = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "col-span-6 md:col-span-4 xl:col-span-3 mb-3",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: "text-sm leading-5 md:text-base md:leading-6 font-semibold text-gray-500 text-left",
                onClick: function() {
                    return setIsShowing(function(isShowing) {
                        return !isShowing;
                    });
                },
                children: "Turbolader Defekte"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "collapseable ".concat(!isShowing && "h-0", " ").concat(isShowing && "h-full", " overflow-hidden transition-[height] duration-700"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    className: "mt-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/turbolader-defekt/",
                                title: "Turbolader defekt",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Turbolader defekt"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/turbolader-reparatur/",
                                title: "Turbolader Reparatur",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Turbolader Reparatur"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/turbolader-ueberholen-instandsetzung/",
                                title: "Turbolader \xfcberholen",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Turbolader \xfcberholen"
                            })
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/Home/ContentElements/Linklists/CarSale.tsx



var CarSale = function(props) {
    var ref = (0,react.useState)(true), isShowing = ref[0], setIsShowing = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "col-span-6 md:col-span-4 xl:col-span-3 mb-3",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: "text-sm leading-5 md:text-base md:leading-6 font-semibold text-gray-500 text-left",
                onClick: function() {
                    return setIsShowing(function(isShowing) {
                        return !isShowing;
                    });
                },
                children: "Autoankauf"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "collapseable ".concat(!isShowing && "h-0", " ").concat(isShowing && "h-full", " overflow-hidden transition-[height] duration-700"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    className: "mt-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/magazin/testberichte/wir-kaufen-dein-auto/",
                                title: "wirkaufendeinauto",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "wirkaufendeinauto"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/magazin/testberichte/abracar/",
                                title: "Abracar",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Abracar"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/magazin/testberichte/mobile-de-express-verkauf-erfahrung/",
                                title: "Mobile.de Express Verkauf",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Mobile.de Express Verkauf"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/was-ist-mein-auto-wert-kostenlos-berechnen/",
                                title: "Schwacke Liste",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Schwacke Liste"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/auto-mit-motorschaden-verkaufen/",
                                title: "Auto mit Motorschaden verkaufen",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "Auto mit Motorschaden verkaufen"
                            })
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/Home/ContentElements/Linklists/TUEVbyRegion.tsx



var TUEVbyRegion = function(props) {
    var ref = (0,react.useState)(true), isShowing = ref[0], setIsShowing = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "col-span-6 md:col-span-4 xl:col-span-3 mb-3",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: "text-sm leading-5 md:text-base md:leading-6 font-semibold text-gray-500 text-left",
                onClick: function() {
                    return setIsShowing(function(isShowing) {
                        return !isShowing;
                    });
                },
                children: "T\xdcV nach Region"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "collapseable ".concat(!isShowing && "h-0", " ").concat(isShowing && "h-full", " overflow-hidden transition-[height] duration-700"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    className: "mt-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/hu-bei-dekra-gtue-kues-oder-tuev-berlin/",
                                title: "HU/AU (T\xdcV) Berlin",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "HU/AU (T\xdcV) Berlin"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/hu-au-tuev-bremen-dekra-gtue-oder-kues/",
                                title: "HU/AU (T\xdcV) Bremen",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "HU/AU (T\xdcV) Bremen"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/hu-bei-dekra-gtue-kues-oder-tuev-bielefeld/",
                                title: "HU/AU (T\xdcV) Bielefeld",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "HU/AU (T\xdcV) Bielefeld"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/hu-bei-dekra-gtue-kues-oder-tuev-bonn/",
                                title: "HU/AU (T\xdcV) Bonn",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "HU/AU (T\xdcV) Bonn"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/hu-bei-dekra-gtue-kues-oder-tuev-duisburg/",
                                title: "HU/AU (T\xdcV) Duisburg",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "HU/AU (T\xdcV) Duisburg"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/hu-bei-dekra-gtue-kues-oder-tuev-dortmund/",
                                title: "HU/AU (T\xdcV) Dortmund",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "HU/AU (T\xdcV) Dortmund"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/hu-bei-dekra-gtue-kues-oder-tuev-duesseldorf/",
                                title: "HU/AU (T\xdcV) D\xfcsseldorf",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "HU/AU (T\xdcV) D\xfcsseldorf"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/hu-bei-dekra-gtue-kues-oder-tuev-frankfurt/",
                                title: "HU/AU (T\xdcV) Frankfurt",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "HU/AU (T\xdcV) Frankfurt"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/hu-au-tuev-landau-dekra-gtue-oder-kues/",
                                title: "HU/AU (T\xdcV) Landau",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "HU/AU (T\xdcV) Landau"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/hu-bei-dekra-gtue-kues-oder-tuev-mainz/",
                                title: "HU/AU (T\xdcV) Mainz",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "HU/AU (T\xdcV) Mainz"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/hu-au-tuev-moenchengladbach-dekra-gtue-oder-kues/",
                                title: "HU/AU (T\xdcV) M\xf6nchengladbach",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "HU/AU (T\xdcV) M\xf6nchengladbach"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/hu-bei-dekra-gtue-kues-oder-tuev-muenchen/",
                                title: "HU/AU (T\xdcV) M\xfcnchen",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "HU/AU (T\xdcV) M\xfcnchen"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/hu-bei-dekra-gtue-kues-oder-tuev-moers/",
                                title: "HU/AU (T\xdcV) Moers",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "HU/AU (T\xdcV) Moers"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/hu-au-tuev-nurnberg-dekra-gtue-oder-kues/",
                                title: "HU/AU (T\xdcV) N\xfcrnberg",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "HU/AU (T\xdcV) N\xfcrnberg"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/hu-bei-dekra-gtue-kues-oder-tuev-paderborn/",
                                title: "HU/AU (T\xdcV) Paderborn",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "HU/AU (T\xdcV) Paderborn"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/hu-bei-dekra-gtue-kues-oder-tuev-pforzheim/",
                                title: "HU/AU (T\xdcV) Pforzheim",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "HU/AU (T\xdcV) Pforzheim"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/hu-au-tuev-tuttlingen-dekra-gtue-oder-kues/",
                                title: "HU/AU (T\xdcV) Tuttlingen",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "HU/AU (T\xdcV) Tuttlingen"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/hu-au-tuev-wiesbaden-dekra-gtue-oder-kues/",
                                title: "HU/AU (T\xdcV) Wiesbaden",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "HU/AU (T\xdcV) Wiesbaden"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.repareo.de/hu-bei-dekra-gtue-kues-oder-tuev-wuerzburg/",
                                title: "HU/AU (T\xdcV) W\xfcrzburg",
                                className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                children: "HU/AU (T\xdcV) W\xfcrzburg"
                            })
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/Home/ContentElements/PopularServices.tsx











var PopularServices = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "popularServices px-6 md:px-12 mb-12 grid grid-cols-12 gap-x-2 md:gap-x-8 lg:gap-x-12",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-span-12",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    className: "text-lg font-serif leading-8 font-semibold text-gray-500 pb-8",
                    children: props.headline
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Cambelt, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InspectionWithBrand, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InspectionWithBrandAndModel, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OilChangeWithModel, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TireChangeWithCity, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CommonIssues, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TurboCharger, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CarSale, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TUEVbyRegion, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-span-6 md:col-span-4 xl:col-span-3 mb-3",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: "https://www.repareo.de/werkstatt-services/",
                    className: "text-base leading-6 font-semibold text-gray-500 text-left no-underline",
                    children: "Alle Services"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-span-6 md:col-span-4 xl:col-span-3 mb-3",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: "https://www.repareo.de/werkstatt-profilseiten/",
                    className: "text-base leading-6 font-semibold text-gray-500 text-left no-underline",
                    children: "Alle Buchbaren Werkst\xe4tten"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "col-span-6 md:col-span-4 xl:col-span-3 mb-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "https://www.repareo.de/werkstatt-in-deiner-naehe/",
                        className: "text-base leading-6 font-semibold text-gray-500 text-left no-underline",
                        children: "Werkstatt in deiner N\xe4he"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        className: "mt-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "pb-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://www.repareo.de/werkstatt/berlin/",
                                    title: "Autowerkst\xe4tten in Berlin",
                                    className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                    children: "Autowerkst\xe4tten in Berlin"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "pb-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://www.repareo.de/werkstatt/muenchen/",
                                    title: "Autowerkst\xe4tten in M\xfcnchen",
                                    className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                    children: "Autowerkst\xe4tten in M\xfcnchen"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "pb-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://www.repareo.de/werkstatt/hamburg/",
                                    title: "Autowerkst\xe4tten in Hamburg",
                                    className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                    children: "Autowerkst\xe4tten in Hamburg"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "pb-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://www.repareo.de/werkstatt/koeln/",
                                    title: "Autowerkst\xe4tten in K\xf6ln",
                                    className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                    children: "Autowerkst\xe4tten in K\xf6ln"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "pb-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://www.repareo.de/werkstatt/leipzig/",
                                    title: "Autowerkst\xe4tten in Leipzig",
                                    className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                    children: "Autowerkst\xe4tten in Leipzig"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "pb-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://www.repareo.de/werkstatt/frankfurt/",
                                    title: "Autowerkst\xe4tten in Frankfurt",
                                    className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                    children: "Autowerkst\xe4tten in Frankfurt"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "pb-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://www.repareo.de/werkstatt/duesseldorf/",
                                    title: "Autowerkst\xe4tten in D\xfcsseldorf",
                                    className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                    children: "Autowerkst\xe4tten in D\xfcsseldorf"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "pb-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://www.repareo.de/werkstatt/dresden/",
                                    title: "Autowerkst\xe4tten in Dresden",
                                    className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                    children: "Autowerkst\xe4tten in Dresden"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "pb-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://www.repareo.de/werkstatt/hannover/",
                                    title: "Autowerkst\xe4tten in Hannover",
                                    className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                    children: "Autowerkst\xe4tten in Hannover"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "pb-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://www.repareo.de/werkstatt/muenster/",
                                    title: "Autowerkst\xe4tten in M\xfcnster",
                                    className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                    children: "Autowerkst\xe4tten in M\xfcnster"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "pb-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://www.repareo.de/werkstatt/braunschweig/",
                                    title: "Autowerkst\xe4tten in Braunschweig",
                                    className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                    children: "Autowerkst\xe4tten in Braunschweig"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "pb-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://www.repareo.de/werkstatt/stuttgart/",
                                    title: "Autowerkst\xe4tten in Stuttgart",
                                    className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                    children: "Autowerkst\xe4tten in Stuttgart"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "pb-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://www.repareo.de/werkstatt/dortmund/",
                                    title: "Autowerkst\xe4tten in Dortmund",
                                    className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                    children: "Autowerkst\xe4tten in Dortmund"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "pb-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://www.repareo.de/werkstatt/essen/",
                                    title: "Autowerkst\xe4tten in Essen",
                                    className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                    children: "Autowerkst\xe4tten in Essen"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "pb-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://www.repareo.de/werkstatt/bremen/",
                                    title: "Autowerkst\xe4tten in Dortmund",
                                    className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                    children: "Autowerkst\xe4tten in Bremen"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "pb-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://www.repareo.de/werkstatt/nuernberg/",
                                    title: "Autowerkst\xe4tten in N\xfcrnberg",
                                    className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                    children: "Autowerkst\xe4tten in N\xfcrnberg"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "pb-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://www.repareo.de/werkstatt/goettingen/",
                                    title: "Autowerkst\xe4tten in G\xf6ttingen",
                                    className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                    children: "Autowerkst\xe4tten in G\xf6ttingen"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "pb-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://www.repareo.de/werkstatt/mainz/",
                                    title: "Autowerkst\xe4tten in Mainz",
                                    className: "text-sm leading-5 font-semibold text-gray-400 no-underline",
                                    children: "Autowerkst\xe4tten in Mainz"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-span-6 md:col-span-4 xl:col-span-3 mb-3",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: "https://www.repareo.de/dekra-stundenverrechungssatz/",
                    className: "text-base leading-6 font-semibold text-gray-500 text-left no-underline",
                    children: "Dekra-Stunden\xadverrechungs\xadsatz"
                })
            })
        ]
    });
};


/***/ })

}]);